import { render, staticRenderFns } from "./create-author.vue?vue&type=template&id=2e30c84c&scoped=true&"
import script from "./create-author.vue?vue&type=script&lang=js&"
export * from "./create-author.vue?vue&type=script&lang=js&"
import style0 from "./create-author.vue?vue&type=style&index=0&id=2e30c84c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30c84c",
  null
  
)

export default component.exports